const API_BASE = '/api';

export async function startScan(url) {
  const res = await fetch(`${API_BASE}/scan`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url })
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || 'Scan failed');
  }
  return res.json();
}

export async function pollProgress(scanId) {
  const res = await fetch(`${API_BASE}/scan/${scanId}/progress`);
  if (!res.ok) throw new Error('Progress fetch failed');
  return res.json();
}

export async function getScanResult(scanId) {
  const res = await fetch(`${API_BASE}/scan/${scanId}`);
  if (!res.ok) throw new Error('Result fetch failed');
  return res.json();
}

export async function getRecentScans() {
  const res = await fetch(`${API_BASE}/scans`);
  if (!res.ok) return [];
  return res.json();
}

export async function getStats() {
  const res = await fetch(`${API_BASE}/stats`);
  if (!res.ok) return null;
  return res.json();
}

export async function getGlobeData() {
  const res = await fetch(`${API_BASE}/globe`);
  if (!res.ok) return [];
  return res.json();
}

export async function fetchLogs(level = null, limit = 200) {
  const params = new URLSearchParams();
  if (level) params.set('level', level);
  if (limit) params.set('limit', limit);
  const res = await fetch(`${API_BASE}/logs?${params.toString()}`);
  if (!res.ok) return [];
  return res.json();
}

export async function fetchScanLogs(scanId) {
  const res = await fetch(`${API_BASE}/logs/${scanId}`);
  if (!res.ok) return [];
  return res.json();
}

export async function fetchComparison(domain) {
  const res = await fetch(`${API_BASE}/compare/${encodeURIComponent(domain)}`);
  if (!res.ok) return null;
  return res.json();
}
